
import { useEffect } from 'react';

interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  onClose: () => void;
  duration?: number;
}

export default function Toast({ message, type, onClose, duration = 5000 }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const bgColors = {
    success: 'bg-emerald-500',
    error: 'bg-red-500',
    info: 'bg-blue-500',
    warning: 'bg-amber-500',
  };

  const icons = {
    success: 'ri-checkbox-circle-line',
    error: 'ri-error-warning-line',
    info: 'ri-information-line',
    warning: 'ri-alert-line',
  };

  return (
    <div className={`${bgColors[type]} text-white px-6 py-4 rounded-lg shadow-lg flex items-center gap-3 min-w-[320px] max-w-md animate-slide-in-right`}>
      <i className={`${icons[type]} text-2xl`}></i>
      <p className="flex-1 text-sm font-medium whitespace-nowrap">{message}</p>
      <button
        onClick={onClose}
        className="text-white/80 hover:text-white transition-colors whitespace-nowrap"
        aria-label="Close notification"
      >
        <i className="ri-close-line text-xl"></i>
      </button>
    </div>
  );
}